module.exports = "/images/product-overview.jpg?94b68ce945cc3c62134e08ea51d45957";